import { render, staticRenderFns } from "./BtnViewReceivedDiff.vue?vue&type=template&id=5ad819ca&"
import script from "./BtnViewReceivedDiff.vue?vue&type=script&lang=js&"
export * from "./BtnViewReceivedDiff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports